<template>
  <router-link class="dropdown-item" :to="{name: 'Statistic'}">
    <span class="nav-link-icon d-md-none d-lg-inline-block">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chart-area-line"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0" /><path d="M4 12l3 -4l4 2l5 -6l4 4" /></svg>
    </span>
    <span class="nav-link-title">
      Статистика
    </span>
  </router-link>
</template>

<script>
export default {
  name: "Statistic",
  setup() {
    return {}
  },
}
</script>

<style scoped>

</style>